import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_ae6d9d3f41d8155d2afb70dc2566bba7/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_ae6d9d3f41d8155d2afb70dc2566bba7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}